import { Component, Input, OnInit } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  providers: [MakeProvider(CheckboxInputComponent)]
})
export class CheckboxInputComponent extends InputComponent implements OnInit {

  @Input() maxWidth: string = 'none';
  
  constructor() { super(); }

  ngOnInit() {}

  override checkValidity() {
    super.checkValidity();
    if (this.isValid) {
      this.checkingValidity.emit(this);
    }
  }
}
